<template>
  <div class="content-list" :class="{'content-list-translate': type == 2}"
    :style="`padding: ${type == 2 ? '0' : type == 1 ? '10px 0 10px' : '38px 0 40px'}; max-width: ${type == 2 ? '100%' : '800px'}`">
    <div class="refresh-icon" v-if="refresh">
      <ChatLoading :size="20" />
    </div>
    <ChatItem v-for="(item,index) in messages" :type="type" :key="index + item.chatId" :index="index" :message="item"
      @updateContentHeight="onUpdateContentHeight" @controls="onControls" @animationFinish="onAnimationFinish"
      @resetSendQusition="onResetSendQusition" @aICheck="onAICheck" @onLinkTitleClick="onLinkTitleClick" />
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
import ChatItem from "@/components/PDFChatComponents/ChatItem/ChatItem.vue"
import ChatLoading from "@/components/PDFChatComponents/ChatLoading.vue"
import type { Message } from '@/data/chat/Message';
let refresh = ref(false)

let call = defineEmits(["updateContentHeight", "controls", "animationFinish", "resetSendQusition", "proBuy", "aICheck", "onLinkTitleClick"])

defineExpose({ updateAddMessage, showRefresh })

interface Props {
  type: number | string,  // 0 源文语言 1 目标语言 
  messages: Message[]
}
const props = defineProps<Props>()
const contentScrollview = ref()

// 新增消息
function updateAddMessage(message: Message) {
  
}

function onLinkTitleClick() {
  call("onLinkTitleClick")
}

function onUpdateContentHeight() {
  call("updateContentHeight")
}

function onControls(index) {
  call("controls", index)
}

function onAnimationFinish() {
  call("animationFinish")
}

function onResetSendQusition(content) {
  call("resetSendQusition", content)
}

function onAICheck(item) {
  call("aICheck", item)
}

function showRefresh(isShow) {
  refresh.value = isShow
}

onMounted(()=>{
  
})

</script>

<style lang="less">
.content-list-translate {
  height: 100%;
}
.content-list {
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  // flex-grow: 1;
  flex:1;
  // overflow-y: auto;
  margin: auto;
  padding: 38px 0 40px;
  .refresh-icon {
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: row;
  }
}

</style>
